import React from 'react';

export const SupportPhoneNumber = () => (<span>(888) 632-3676</span>);
export const PdapSupportPhoneNumber = () => (<span>(833) 201-0142</span>);